// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { createContext } from 'react';

interface VolumeContextType {
  volumes: Record<string, number>; // participantId -> volume
  setVolume: (participantId: string, volume: number) => void;
  getVolume: (participantId: string) => number;
  mutedParticipants: string[];
  muteParticipant: (participantId: string) => void;
  unmuteParticipant: (participantId: string) => void;
  isMuted: (participantId: string) => boolean;
  positions: Record<string, { x: number; y: number; z: number }>;
  setPosition: (participantId: string, pos: { x: number; y: number; z: number }, channelId: string) => void;
}

export const VolumeContext = createContext<VolumeContextType>({
  volumes: {},
  setVolume: () => {},
  getVolume: () => 1.0,
  mutedParticipants: [],
  muteParticipant: () => {},
  unmuteParticipant: () => {},
  isMuted: () => false,
  positions: {},
  setPosition: () => {},
});
